import { Button as MuiButton, FormControl } from "@mui/material";
import { LoadingButton as MuiLoadingButton } from "@mui/lab";
import { SizingWrapper, type ISizingWrapperProps } from "../Wrapper";

enum VariantOption {
  Text = "text",
  Outlined = "outlined",
  Contained = "contained",
}

enum ColorOption {
  Inherit = "inherit",
  Primary = "primary",
  Secondary = "secondary",
  Success = "success",
  Error = "error",
  Info = "info",
  Warning = "warning",
}

interface IProps extends ISizingWrapperProps {
  label: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  variant: VariantOption;
  color?: ColorOption;
  fullWidth?: boolean;
  disabled?: boolean;
  startIcon?: React.ReactNode;
  type?: "button" | "submit" | "reset";
  hasLoading?: boolean;
  loading?: boolean;
}

const Button: React.FC<IProps> = (props) => {
  const {
    label,
    onClick,
    variant,
    color = ColorOption.Primary,
    fullWidth = false,
    size,
    disabled = false,
    startIcon,
    type = "button",
    hasLoading = false,
    loading = false,
  } = props;

  return (
    <SizingWrapper size={size}>
      <FormControl fullWidth>
        {hasLoading ? (
          <MuiLoadingButton
            variant={variant}
            onClick={onClick}
            color={color}
            fullWidth={fullWidth}
            disabled={disabled}
            startIcon={startIcon}
            type={type}
            loading={loading}
          >
            {label}
          </MuiLoadingButton>
        ) : (
          <MuiButton
            variant={variant}
            onClick={onClick}
            color={color}
            fullWidth={fullWidth}
            disabled={disabled}
            startIcon={startIcon}
            type={type}
          >
            {label}
          </MuiButton>
        )}
      </FormControl>
    </SizingWrapper>
  );
};

export {
  Button,
  VariantOption as ButtonVariantOption,
  ColorOption as ButtonColorOption,
  type IProps,
};
